import { ChangeDetectionStrategy, Component } from '@angular/core';
import { User } from '@src/app/_models/user/user';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { registerLocaleData } from '@angular/common';
import { UntilDestroy } from '@ngneat/until-destroy';
import moment from 'moment';
import localeCs from '@angular/common/locales/cs';

moment.updateLocale('cs', { workingWeekdays: [1, 2, 3, 4, 5] });
registerLocaleData(localeCs);

@UntilDestroy()
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
    currentUser: User | null;

    constructor(private readonly authenticationService: AuthenticationService) {
        this.currentUser = this.authenticationService.currentUserValue;
    }
}
